import React from 'react';
import {Breadcrumb} from "flowbite-react";
import {HiHome} from "react-icons/hi";
import {IoDocumentText} from "react-icons/io5";
import DocSection from "./DocSection";

const TelegramBotDoc = () => {
    return (
        <section className="bg-white dark:bg-gray-700">
            <Breadcrumb aria-label="Breadcrumb navigation" className="bg-gray-100 px-5 py-3 dark:bg-gray-900">
                <Breadcrumb.Item href="/" icon={HiHome}>Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/documentation" icon={IoDocumentText}>Documentation</Breadcrumb.Item>
                <Breadcrumb.Item>
                    <span className="text-gray-900 dark:text-white">Telegram Bot Guide</span>
                </Breadcrumb.Item>
            </Breadcrumb>

            <div className="mx-auto max-w-screen-md text-center my-8">
                <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">
                    Telegram Bot Guide
                </h1>
                <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
                    Step-by-step instructions on integrating and utilizing our Telegram bot
                </p>
            </div>

            <div className="mx-auto max-w-screen-lg pb-8">
                <h2 className="text-2xl text-gray-700 dark:text-gray-300 mb-4">
                    Available Commands:
                </h2>

                <DocSection
                    title="/start - Start the bot"
                    description="Start the bot to register and begin receiving tokens for your forms."
                    examples={[]}
                    alert={{ color: "failure", message: "Our bot is available at @FormyAgentBot. Any other bot using the name Formy is not valid." }}
                />

                <DocSection
                    title="/get_token FORM_NAME - Retrieve a form token"
                    description="Obtain a token for a specific form by replacing FORM_NAME with the name of your form."
                    examples={["/get_token test"]}
                />

                <DocSection
                    title="/tokens_list - View form tokens"
                    description="Displays a list of your acquired tokens. You can also revoke them when necessary."
                    examples={[]}
                    alert={{ color: "failure", message: "For security reasons, periodically revoke and regenerate your tokens." }}
                />

                <DocSection
                    title="/add_domain DOMAIN - Add an authorized domain"
                    description="Register a domain to allow form data submissions from it."
                    examples={["/add_domain abolfazlmohajeri.ir", "/add_domain localhost"]}
                    alert={{ color: "failure", message: "Use 'localhost' only for testing purposes." }}
                />

                <DocSection
                    title="/domains_list - Manage allowed domains"
                    description="Lists your authorized domains and allows you to modify them. Requests will be validated
                    based on the referrer or origin request header. If your domains are not registered, form data will
                    not be received."
                    examples={[]}
                    alert={{ color: "failure", message: "To prevent spam, ensure you add only the necessary domains." }}
                />
            </div>
        </section>
    );
};

export default TelegramBotDoc;
